import React, { Component } from "react";

import { Link } from "react-router-dom";

class TravelRequestCreateStep1 extends Component {
  renderStep(label, status, active) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1 }}>
        <div
          style={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            background: active ? "#1464E9" : "#EEF2F7",
            color: active ? "#fff" : "#334155",
            textAlign: "center",
            lineHeight: "38px",
            fontWeight: 900,
          }}
        >
          {status.no}
        </div>
        <div>
          <div style={{ fontWeight: 900, color: active ? "#1464E9" : "#334155" }}>
            {label}
          </div>
          <div style={{ fontSize: 12, color: "#64748B" }}>{status.text}</div>
        </div>
      </div>
    );
  }

  renderInput(label, value, wide) {
    return (
      <div style={{ gridColumn: wide ? "1 / span 3" : "auto" }}>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly style={inputStyle} />
      </div>
    );
  }

  renderProcess(no, title, desc, color) {
    return (
      <div style={{ display: "flex", gap: 16, marginBottom: 28 }}>
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            background: color,
            color: "#fff",
            textAlign: "center",
            lineHeight: "34px",
            fontWeight: 900,
          }}
        >
          {no}
        </div>
        <div>
          <div style={{ fontWeight: 900, color: "#0F172A" }}>{title}</div>
          <div style={{ color: "#64748B", fontSize: 13, lineHeight: "22px", marginTop: 6 }}>
            {desc}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h3 style={{ margin: 0, color: "#0F172A", fontWeight: 900 }}>
            Create Travel Request
          </h3>
          <div style={{ marginTop: 8, color: "#64748B", fontSize: 13 }}>
            Travel & Budget &nbsp;›&nbsp; Travel Request &nbsp;›&nbsp; Create
          </div>
        </div>

        <div style={stepWrapper}>
          {this.renderStep("Traveler & Trip Details", { no: 1, text: "In Progress" }, true)}
          {this.renderStep("Schedule & Accommodation", { no: 2, text: "Pending" }, false)}
          {this.renderStep("Cash Advance", { no: 3, text: "Pending" }, false)}
          {this.renderStep("Documents", { no: 4, text: "Pending" }, false)}
          {this.renderStep("Review & Submit", { no: 5, text: "Pending" }, false)}
        </div>

        <div style={infoBox}>
          <b style={{ color: "#1464E9", marginRight: 10 }}>i</b>
          The completed travel request form must first be submitted to the applicant's manager /
          supervisor for travel approval.
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 390px", gap: 22 }}>
          <div style={card}>
            <h4 style={sectionTitle}>1. Traveler Information</h4>

            <div style={grid3}>
              {this.renderInput("Name *", "ALLISTAIR LORENZO JAMES")}
              {this.renderInput("Title *", "CRM EXECUTIVE")}
              {this.renderInput("Date *", "16/03/2023")}
              {this.renderInput("Reporting Manager *", "DYLAN REDAS NOEL", true)}
            </div>

            <div style={divider} />

            <h4 style={sectionTitle}>2. Trip Information</h4>

            <div style={grid2}>
              {this.renderInput("Proposed Departure Date *", "19/04/2023")}
              {this.renderInput("Proposed Return Date *", "01/05/2023")}
            </div>

            <div style={{ marginTop: 16 }}>
              <label style={labelStyle}>Trip Description / Purpose *</label>
              <textarea
                value={"TO ATTEND THE SIMPLEVIEW SUMMIT 2023 IN HOUSTON, TEXAS\nFROM 23RD - 26TH APRIL"}
                readOnly
                rows={4}
                style={textareaStyle}
              />
              <div style={{ textAlign: "right", fontSize: 12, color: "#64748B", marginTop: -22, paddingRight: 10 }}>
                73 / 500
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginTop: 20 }}>
              <div>
                <label style={labelStyle}>Transportation Mode *</label>
                <div style={{ display: "flex", gap: 24, marginTop: 12 }}>
                  {["Air", "Train", "Bus", "Vehicle", "Ship"].map((x, i) => (
                    <label key={x} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 14 }}>
                      <input type="radio" checked={i === 0} readOnly />
                      {x}
                    </label>
                  ))}
                </div>
              </div>

              {this.renderInput("Project Code *", "1) DIGITALIZATION OF BESARAWAK & INDUSTRY")}
            </div>

            <div style={{ marginTop: 16 }}>
              {this.renderInput("Destination / Country *", "HOUSTON, USA", true)}
            </div>
          </div>

          <div style={card}>
            <h4 style={{ ...sectionTitle, marginBottom: 28 }}>Travel Request Process</h4>

            {this.renderProcess(
              1,
              "Submitted by Staff",
              "Staff submits the travel request form with trip details.",
              "#1464E9"
            )}
            {this.renderProcess(
              2,
              "Approved by Manager / Supervisor",
              "Manager or supervisor reviews and approves the request.",
              "#10B981"
            )}
            {this.renderProcess(
              3,
              "Admin Handles Bookings",
              "Admin proceeds with the necessary bookings after approval.",
              "#F97316"
            )}
            {this.renderProcess(
              4,
              "Finance Handles Payment",
              "Finance processes payment after receiving booking confirmations.",
              "#7C3AED"
            )}
          </div>
        </div>

        <div style={footerBar}>
          <Link to="/travel" style={secondaryButtonLink}>← Back</Link>

          <div style={{ display: "flex", gap: 12 }}>
            <button style={secondaryButton}>Save Draft</button>
			<Link to="/travel/create/step-2" style={primaryButtonLink}>
			  Next →
			</Link>
          </div>
        </div>
      </div>
    );
  }
}

const stepWrapper = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 22,
  display: "flex",
  gap: 18,
  marginBottom: 18,
};

const infoBox = {
  background: "#EAF3FF",
  border: "1px solid #BFDBFE",
  borderRadius: 10,
  padding: "14px 18px",
  color: "#334155",
  marginBottom: 20,
  fontSize: 14,
};

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 24,
};

const sectionTitle = {
  margin: "0 0 18px",
  color: "#0F172A",
  fontWeight: 900,
};

const grid3 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 220px",
  gap: 18,
};

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 18,
};

const labelStyle = {
  display: "block",
  fontSize: 13,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 42,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 14px",
  fontSize: 14,
  color: "#334155",
  background: "#fff",
};

const textareaStyle = {
  width: "100%",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: 14,
  fontSize: 14,
  color: "#334155",
  resize: "vertical",
};

const divider = {
  height: 1,
  background: "#E5E7EB",
  margin: "28px 0 22px",
};

const footerBar = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginTop: 18,
  display: "flex",
  justifyContent: "space-between",
};

const primaryButton = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "12px 28px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "11px 24px",
  fontWeight: 800,
};

const primaryButtonLink = {
  ...primaryButton,
  textDecoration: "none",
  display: "inline-block",
};

const secondaryButtonLink = {
  ...secondaryButton,
  textDecoration: "none",
  display: "inline-block",
};


export default TravelRequestCreateStep1;